import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tooltip from 'components/tooltip';

export default class SelectableRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    disabledMessage: PropTypes.string,
    hideCheckbox: PropTypes.bool,
    responsive: PropTypes.bool,
    selected: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    responsive: true,
    onChange: () => { },
  };

  handleChange = (event) => {
    const selected = event.target.checked;
    this.props.onChange(event, selected);
  };

  render() {
    const {
      children,
      className: customRowClass,
      disabled,
      disabledMessage,
      hideCheckbox,
      responsive,
      selected,
      onChange,
      ...rowProps
    } = this.props;

    const rowClass = classNames('selectable-row align-middle', customRowClass, { selected });

    // TODO: Clean up - the disabled flag should be all that counts
    const checkboxDisabled = disabled || disabledMessage != null;
    const className = classNames('checkbox-cell sticky-cell', {
      'd-none d-lg-table-cell': responsive,
    });

    return (
      <tr className={rowClass} {...rowProps}>
        {!hideCheckbox && (
          <td className={className}>
            {disabledMessage
              ? this.renderCheckboxWithTooltip()
              : this.renderCheckbox(checkboxDisabled)}
          </td>
        )}
        {children}
      </tr>
    );
  }

  renderCheckbox(disabled) {
    const { selected } = this.props;

    return (
      <input
        checked={selected || false}
        className="form-check-input"
        disabled={disabled}
        type="checkbox"
        onChange={this.handleChange}
      />
    );
  }

  renderCheckboxWithTooltip() {
    return (
      <Tooltip content={this.props.disabledMessage} placement="right">
        <div>
          {this.renderCheckbox(true)}
        </div>
      </Tooltip>
    );
  }
}
